/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomPaginationService } from 'src/services/custom-pagination.service';
import { Page } from 'src/app/page';
import { CpsuSubjectService } from 'src/services/cpsu-subject.service';

@Component({
   selector: 'app-cpsu-subject-history',
   templateUrl: './cpsu-subject-history.component.html',
   styleUrls: ['./cpsu-subject-history.component.scss'],
})
export class CpsuSubjectHistoryComponent implements OnInit {
   page: Page<Object> = new Page();
   selectedRow: { id: number };
   id: string;

   displayedColumns: string[] = [
      'dateOfModification',
      'csrName',
      'modifiedBy',
      'registrationId',
      'dateOfCreation',
      'lastName',
      'firstName',
      'parentName',
      'dateOfBirth',
      'yearOfBirth',
      'gender',
      'jmbg',
      'jmbp',
      'statusCsr',
      'statusCpsu',
      'familyDossier',
      'familyType',
      'placeOfBirth',
      'nationality',
      'citizenship',
      'category',
      'nativeLanguage',
      'disabledPerson',
      'disabilityType',
      'ableToWork',
      'occupation',
      'employment',
      'education',
      'levelOfEducation',
      'schoolAttending',
      'businessAbility',
      'deprivationExtent',
      'maritalStatus',
      'residence',
      'permanentResidence',
      'phone',
      'mobile',
      'email',
      'note',
      'note1',
      'note2',
      'note3',
      'dossierOwnerCsr',
      'dossierOwnerCpsu',
      'familyMembersNames',
   ];
   constructor(
      private route: ActivatedRoute,
      private paginationService: CustomPaginationService,
      private cdr: ChangeDetectorRef,
      private cpsuSubjectService: CpsuSubjectService
   ) {
      this.route.params.subscribe(params => {
         this.id = params.id;
      });
      this.getData();
   }

   getData() {
      this.cpsuSubjectService.getHistoryPage(this.page.pageable, this.id).subscribe(page => {
         this.page = page;
         this.page.pageable.pagePerShow = page.number + 1;
         for (const element of this.page.content) {
            (element as any).dateOfModification = (element as any).dateOfModification.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
            (element as any).dateOfCreation = (element as any).dateOfCreation.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
            if ((element as any).dateOfBirth !== null) {
               (element as any).dateOfBirth = (element as any).dateOfBirth.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
            }
         }
         this.cdr.detectChanges();
      });
   }

   public getNextPage(): void {
      this.page.pageable = this.paginationService.getNextPage(this.page);
      this.getData();
   }

   public getPreviousPage(): void {
      this.page.pageable = this.paginationService.getPreviousPage(this.page);
      this.getData();
   }

   public getFirstPage(): void {
      this.page.pageable = this.paginationService.getFirstPage(this.page);
      this.getData();
   }

   public getLastPage(): void {
      this.page.pageable = this.paginationService.getLastPage(this.page);
      this.getData();
   }

   public getPageInNewSize(pageSize: number): void {
      this.page.pageable = this.paginationService.getPageInNewSize(this.page, pageSize);
      this.getData();
   }

   ngOnInit(): void {}
}
